import Button from "@components/buttons/Button"
import { Container as ImageHelperContainer } from "@components/ImageHelper"
import Media from "@components/Media"
import { Container as GifContainer, GifWrapper } from "@components/Media/Gif"
import { Container as ImageContainer } from "@components/Media/Image"
import {
  Container as MuxContainer,
  Content as MuxWrapper,
} from "@components/Media/Mux"
import {
  Container as VideoContainer,
  VideoWrapper,
} from "@components/Media/Video"
import {
  Container as WistiaContainer,
  Content as WistiaWrapper,
} from "@components/Media/Wistia"
import {
  Container as YoutubeContainer,
  Content as YoutubeWrapper,
} from "@components/Media/YouTube"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body14Styles,
  paragraph18Styles,
  paragraph20Styles,
  paragraphStyles,
  subtextStyles,
} from "@constants/typography"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  @media ${breakpoints.laptop} {
    display: flex;
  }
`

const ContentWrapper = styled.div`
  flex-direction: column;
  display: flex;
  padding-top: 40px;

  ${GifContainer}, ${ImageContainer}, ${VideoContainer}, ${WistiaContainer}, ${YoutubeContainer}, ${MuxContainer} {
    padding: 0;
  }

  @media ${breakpoints.tablet} {
    padding-top: 61px;

    ${GifContainer}, ${ImageContainer}, ${VideoContainer}, ${WistiaContainer}, ${YoutubeContainer}, ${MuxContainer} {
      padding: 0;
    }

    ${GifWrapper}, ${ImageHelperContainer}, ${VideoWrapper}, ${WistiaWrapper}, ${YoutubeWrapper}, ${MuxWrapper} {
      width: 100%;
      height: calc(100vh - 120px);
    }
  }

  @media ${breakpoints.laptop} {
    width: 100%;
    padding-top: 54px;

    ${GifContainer}, ${ImageContainer}, ${VideoContainer}, ${WistiaContainer}, ${YoutubeContainer}, ${MuxContainer} {
      padding: 0;
    }

    ${GifWrapper}, ${ImageHelperContainer}, ${VideoWrapper}, ${WistiaWrapper}, ${YoutubeWrapper}, ${MuxWrapper} {
      width: 100%;
      height: calc(10 / 12 * 100vw * 0.51);
    }
  }
`

const Text = styled.div`
  margin-bottom: 31px;
  padding: 0 20px;

  h6 {
    ${body14Styles}
    margin: 0 0 34px;
  }

  p {
    ${paragraph20Styles}
    margin: 0 0 34px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  p.finePrint {
    ${subtextStyles}
    margin: 0 0 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul {
    margin: 0 0 34px;
    padding-left: 18px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  li {
    color: ${colors.mediumDarkGray};

    p {
      ${paragraphStyles}
      color: ${colors.mediumDarkGray};
    }
  }

  @media ${breakpoints.tablet} {
    padding: 0 calc(2.5 / 12 * 100vw) 0 calc(1 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    margin-bottom: 22px;
    padding: 0;

    h6 {
      margin-bottom: 41px;
    }

    p {
      margin-bottom: 41px;
      font-size: 22px;
      line-height: 33px;
    }

    p.finePrint {
      ${subtextStyles}
      margin-bottom: 12px;
    }

    ul {
      margin-bottom: 41px;
    }

    li {
      p {
        ${paragraph18Styles}
        color: ${colors.mediumDarkGray};
      }
    }
  }
`

const DownloadWrapper = styled.div`
  padding: 0 20px;

  @media ${breakpoints.laptop} {
    width: 320px;
    padding: 0;
  }
`

const Download = styled.a`
  width: 100%;

  @media ${breakpoints.laptop} {
    width: 320px;
  }
`

const InstallationBlock = ({ image, media, text }) => {
  return (
    <Container>
      <ContentWrapper>
        <Text>{text}</Text>
        {media && (
          <Media
            autoplayVideo={media.autoplayVideo}
            caption={media.caption}
            customVideoThumbnail={media.customVideoThumbnail?.file?.url}
            gif={media.gif?.file?.url}
            image={media.image?.file?.url}
            mobileGif={media.mobileGif?.file?.url}
            mobileImage={media.mobileImage?.file?.url}
            mobileVideoUrl={media.mobileVideoUrl}
            muxMobileVideo={media.muxMobileVideo}
            muxVideo={media.muxVideo}
            type={media.type}
            videoThumbnail={media.videoThumbnail}
            videoUrl={media.videoUrl}
            wistiaVideoId={media.wistiaVideoId}
            youtubeVideoId={media.youtubeVideoId}
          />
        )}
        {image && (
          <DownloadWrapper>
            <Download download href={image?.file?.url || ""} target="_blank">
              <Button text="Download" />
            </Download>
          </DownloadWrapper>
        )}
      </ContentWrapper>
    </Container>
  )
}

export default InstallationBlock
